module.exports = __webpack_public_path__ + "static/lotus-1b8eabc1217e639bef8892faddcf9e23.jpg";